export const DEFAULT_VISIBLE_ROWS = 5
export const MAX_WIDGET_ROWS = 20

/**
 * @param {number|string|null|undefined} value
 * @returns {number}
 */
export function normalizeInitialVisibleRows(value) {
    const count = Number(value)
    if (!Number.isFinite(count) || count <= 0) {
        return DEFAULT_VISIBLE_ROWS
    }
    if (count > MAX_WIDGET_ROWS) {
        return MAX_WIDGET_ROWS
    }
    return Math.floor(count)
}

/**
 * @param {{ visibleRows?: number, offset?: number, rowCount?: number }} params
 * @returns {number}
 */
export function getInitialDisplayedCount(params) {
    const source = params || {}
    const rows = Math.max(Number(source.rowCount) || 0, 0)
    const start = Number(source.offset) || 0
    if (start > 0) {
        return Math.min(MAX_WIDGET_ROWS, rows)
    }
    return Math.min(normalizeInitialVisibleRows(source.visibleRows), rows)
}

/**
 * @param {{ displayed?: number, total?: number, offset?: number, rowCount?: number }} params
 * @returns {number}
 */
export function getExpandMoreCount(params) {
    const source = params || {}
    const shown = Math.max(Number(source.displayed) || 0, 0)
    const rows = Math.max(Number(source.rowCount) || 0, 0)
    const start = Number(source.offset) || 0
    const listTotal = Number.isFinite(Number(source.total)) ? Number(source.total) : start + rows
    const cap = Math.min(MAX_WIDGET_ROWS, Math.max(listTotal - start, 0), rows)
    if (shown >= cap) {
        return 0
    }
    return cap - shown
}

/**
 * @param {{ displayed?: number, total?: number, offset?: number }} params
 * @returns {number}
 */
export function getShowNextCount(params) {
    const source = params || {}
    const shown = Math.max(Number(source.displayed) || 0, 0)
    if (shown !== MAX_WIDGET_ROWS) {
        return 0
    }
    const start = Number(source.offset) || 0
    const listTotal = Number(source.total)
    if (!Number.isFinite(listTotal)) {
        return 0
    }
    const remaining = listTotal - start - shown
    if (remaining <= 0) {
        return 0
    }
    return Math.min(MAX_WIDGET_ROWS, remaining)
}

/**
 * @param {Array<{ showRadio?: boolean }>|null|undefined} rows
 * @returns {boolean}
 */
export function hasRadioRows(rows) {
    if (!Array.isArray(rows)) {
        return false
    }
    return rows.some((row) => Boolean(row && row.showRadio))
}
